import { NumberInputBase } from 'app/shared/elements/forms/number-input-base';
import { bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';

@bindable({ name: 'value', defaultBindingMode: bindingMode.twoWay })
@bindable.numberNull({ name: 'min' })
@bindable.numberNull({ name: 'max' })
@bindable.numberNull({ name: 'minLength' })
@bindable.numberNull({ name: 'step' })
@bindable.stringNull({ name: 'label' })
@bindable.stringNull({ name: 'placeholder' })
@bindable.stringNull({ name: 'icon' })
@bindable.booleanAttr({ name: 'required' })
@bindable.booleanAttr({ name: 'readonly' })
@bindable.booleanAttr({ name: 'disabled' })
@bindable.stringNull({ name: 'autocomplete' })
@bindable.stringNull({ name: 'testPrefix' })
@bindable.stringNull({ name: 'requiredValidatorLabel' })
@bindable.stringNull({ name: 'labelledbyId' })
export class EssIntegerCustomElement extends NumberInputBase {
    protected readonly precision: number = 0;
    public testPrefix = 'num';
    @bindable.string()
    public testName: string = '';

    @bindable.stringNull()
    public arialabelValue: string | null = null;
}
